import AlertModal from "./alertModal";
import Tools from "../../../base/components/tools";

export default class FormularioEntrada extends React.Component {
    constructor(props) {
        super(props);

        this.pnpService = new ServicioPnp();
        this.tools = new Tools();

        this.state = {
            form: {
                fullName: { error: "", valid: "", value: "" },
                identificationType: { error: "", valid: "", value: "Seleccione un documento", sigla: "" },
                identificationNumber: { error: "", valid: "", value: "" },
                phone: { error: "", valid: "", value: "" },
                email: { error: "", valid: "", value: "" },
                confirmEmail: { error: "", valid: "", value: "" },
                isContacted: { error: "", valid: "", value: "" },
                confirmPersonalData: { error: "", valid: "", value: true },
                confirmEmailMessage: { error: "", valid: "", value: true },
                confirmTextMessage: { error: "", valid: "", value: true }
            },
            isSubmitted: false,
            typeDocList: [],
            isDisabled: true,
            formIsValid: false,
            politicaTratamientoDatos: null,
            showModal: false,
            showModalPlanVital: false
        };

        this.errorMessages = {
            required: 'es requerido',
            maxlength: 'ha excedido del valor maximo permitido',
            email: 'Por favor ingrese una dirección de correo',
            equalTo: 'No es igual al correo personal',
            number: 'solo permite números',
            isEmailRequired: 'es requerida',
            minlength: 'debe contener un mínimo de 10 dígitos',
            alphanumeric: 'No permite caracteres especiales'
        }

        this.setRulesForm = this.setRulesForm.bind(this);
        this.saludValidaciones = new SaludValidaciones(this.state.form, this.setRulesForm());
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.getDocType = this.getDocType.bind(this);
        this.setCursorAtBegin = this.setCursorAtBegin.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.removeEmojis = this.removeEmojis.bind(this);
        this.removeNonLetters = this.removeNonLetters.bind(this);
        this.removeLetters = this.removeLetters.bind(this);

        $(window).keyup((e) => {
            var code = (e.keyCode ? e.keyCode : e.which);
            if (code == 9 && $('#confirmEmail:focus').length && $('#confirmEmail').val() == '@') {
                const input = document.getElementById("confirmEmail");
                input.setSelectionRange(0, 0);
            }
        });
    }

    componentDidMount() {
        this.pnpService.getList('tiposDocumento', (list) => {
            this.setState({ typeDocList: list }, (() => {
            }));
        });
        this.pnpService.getListByTitle('AdministracionTerminosCondiciones', (item) => {
            let planComplementario = item.filter(item => item.Funcionalidad == "TerminosCotizadorPlanComplementario");
            let planVital = item.filter(item => item.Funcionalidad == "TerminosCotizadorPlanVital");
            this.setState({ politicaTratamientoDatos: planComplementario[0], politicaTratamientoDatosPlanVital: planVital[0] });
        }, "", "TerminosCondiciones", "Title", "Funcionalidad");
    }

    componentWillReceiveProps(props) {
        const showModalPlanVital = props.showModalPlanVital;
        const name = { ...this.state.form }; name.fullName.value = props.form.name.value;
        const email = { ...this.state.form }; email.email.value = props.form.email.value;
        const identificationType = { ...this.state.form }; identificationType.identificationType.value = props.form.identificationType.value;
        const identificationTypeSigla = { ...this.state.form }; identificationType.identificationType.sigla = props.form.identificationType.sigla;
        const identificationNumber = { ...this.state.form }; identificationNumber.identificationNumber.value = props.form.identificationNumber.value;
        const phone = { ...this.state.form }; phone.phone.value = props.form.phone.value;
        this.setState({ form: name, form: email, form: identificationType, form: identificationTypeSigla, form: identificationNumber, form: phone, showModalPlanVital })
        // this.setState({ form: props.form });
    }


    getDocType(docType) {
        if (docType !== 'Seleccionar') {
            const typeDocList = this.state['typeDocList'];
            let typeDoc = typeDocList.find(elem => elem.CSDocumentoIdentidadText === docType || elem.CSIdDocumentoText === docType);
            return typeDoc.CSSiglaText;
        } else {
            return null;
        }

    }

    UrlCatcher() {
        var ultimaPosicion = window.location.pathname.split("/");
        var nivelAnterior = ultimaPosicion.slice(ultimaPosicion.length - 1);
        var text = "";
        nivelAnterior.forEach((item) => {
            text = text + "/" + item;
        });
        return decodeURI(text).slice(1);
    }

    setRulesForm() {
        const email = this.state.form.email.value;
        const rules = {
            fullName: {
                required: true,
                maxlength: 105
            },
            email: {
                email: true
            },
            confirmEmail: {
                email: true,
                equalTo: (value) => {
                    return value.trim().toLowerCase() === this.state.form.email.value.trim().toLowerCase() && this.state.form.email.value.trim().toLowerCase();
                },
                required: () => {
                    return this.state.form.email.value;
                }
            },
            identificationNumber: {
                maxlength: 60,
                required: true,
                alphanumeric: (value) => {
                    return /^[ _]*[a-zA-Z0-9  áéíóúÁÉÍÓÚñÑ]*$/.test(value) && value.trim() != '';
                }
            },
            identificationType: {
                required: true
            },
            phone: {
                required: true,
                maxlength: 10,
                number: true,
                minlength: 10
            }
        };
        return rules;
    }

    handleInputChange(event) {
        if (event) {
            const target = event.target;
            const value = target.type === 'checkbox' ? target.checked : target.value;
            if (target.name === 'fullName') {
                let nameValidated = this.removeEmojis(value);
                nameValidated = this.removeNonLetters(value);
                const name = target.name;
                let FormValues = this.state.form;
                FormValues[name].value = nameValidated;
                this.setState({
                    form: FormValues
                }, () => { this.validateForm(); });
            }
            else if (target.name === 'identificationNumber' || target.name === 'phone') {
                let idValidated = this.removeLetters(value);
                const name = target.name;
                let FormValues = this.state.form;
                FormValues[name].value = idValidated;
                this.setState({
                    form: FormValues
                }, () => { this.validateForm(); });
            }
            else {
                const name = target.name;
                let FormValues = this.state.form;
                FormValues[name].value = value;
                this.setState({
                    form: FormValues
                }, () => { this.validateForm(); });
            }
        }
        this.handleBlur(event)
    }

    handleSelect(item) {
        let FormValues = this.state.form;
        FormValues['identificationType'].value = item.CSDocumentoIdentidadText;
        let IdSigla = this.state.form;
        IdSigla['identificationType'].sigla = item.CSSiglaText;
        IdSigla['identificationType'].id = item.CSIdDocumentoText
        this.setState({
            form: FormValues, form: IdSigla
        }, () => { this.validateForm(); });
    }

    handleSubmit(event, boolean) {
        let userInfoCheck = compTools.obtenerInformacionUsuario();
        event.preventDefault();
        dataLayer.push({
            event: "cotizacion_plan",
            user_id: userInfoCheck.Nautcli,
            log_status: "true",
            login_type: userInfoCheck.TipoIdentificacion == 2 ? "Empresas" : "Personas",
            affiliation: "Salud",
            bread_crumbs: this.UrlCatcher(),
            step: "Paso 1",
            option: "Cotiza Plan Complementario Especial"
        })
        this.props.updateState(this.state.form, 2);
    }

    handlePlanVital() {
        let userInfoCheck = compTools.obtenerInformacionUsuario();
        dataLayer.push({
            event: "cotizacion_plan",
            user_id: userInfoCheck.Nautcli,
            log_status: "true",
            login_type: userInfoCheck.TipoIdentificacion == 2 ? "Empresas" : "Personas",
            affiliation: "Salud",
            bread_crumbs: this.UrlCatcher(),
            step: "Paso 1",
            option: "Cotiza Plan Vital"
        })
        this.setState({ showModalPlanVital: true });
    }

    handleBlur(event, elementId) {
        let currentForm = JSON.parse(JSON.stringify(this.state.form));
        let element = event.target;
        this.saludValidaciones.validateField(element, currentForm);
        this.setState({ form: currentForm }, () => { this.validateForm(); });
    }

    handleFocus(event) {
        let currentForm = JSON.parse(JSON.stringify(this.state.form));
        if (!event.target.value) {
            currentForm[event.target.id].value = '@';
            this.setCursorAtBegin();
        }
        this.setState({ form: currentForm });
    }

    setCursorAtBegin() {
        let currentForm = JSON.parse(JSON.stringify(this.state.form));
        if (currentForm['email'].value == '@') {
            const input = document.getElementById("email");
            input.setSelectionRange(0, 0);
            // this.validateForm()
        } else if (currentForm['confirmEmail'].value == '@') {
            const input = document.getElementById("confirmEmail");
            input.setSelectionRange(0, 0);
        }
        currentForm.confirmEmail.value.toLowerCase() == currentForm.email.value.toLowerCase() ? currentForm.confirmEmail.valid = true : currentForm.confirmEmail.valid = false
        this.setState({ form: currentForm })
        this.validateForm()
    }

    removeEmojis(string) {
        const regex = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;
        return string.replace(regex, '');
    }

    removeNonLetters(string) {
        const regex = /[^a-zA-Z\s]/gi;
        return string.replace(regex, '');
    }

    removeLetters(string) {
        const regex = /\D+/g;
        return string.replace(regex, '');
    }

    validateForm() {
        if (
            this.state.form.confirmEmail.value.toLowerCase() == this.state.form.email.value.toLowerCase() &&
            this.state.form.confirmEmailMessage.value === true &&
            this.state.form.confirmPersonalData.value === true &&
            this.state.form.confirmTextMessage.value === true &&
            this.state.form.email.valid === true && this.state.form.email.value !== '@' && this.state.form.email.value !== '' &&
            this.state.form.phone.valid === true && this.state.form.phone.value !== "" &&
            this.state.form.fullName.valid === true && this.state.form.fullName.value !== "" &&
            this.state.form.identificationNumber.valid === true && this.state.form.identificationNumber.value !== "" &&
            this.state.form.identificationType.valid === true && this.state.form.identificationType.value !== "" && this.state.form.identificationType.value !== 'Seleccione un docuemnto'
        ) {
            this.setState({ formIsValid: true });
        } else {
            this.setState({ formIsValid: false });
        }
    }

    handleHide(boolean) {
        this.setState({ showModal: boolean, showModalPlanVital: false })
    }

    innerHtml(title) {
        return { __html: title }
    }

    render() {
        let loginURL = '';
        if (Object.keys(this.props.configurations).length) {
            loginURL = this.tools.getLoginURL(this.props.configurations['FBA_CLAIM']);
        }
        return (
            <div>
                {this.state.showModal == true ?
                    <AlertModal
                        showModal={true}
                        handleHide={this.handleHide.bind(this)}
                        msg={<div dangerouslySetInnerHTML={this.innerHtml(this.state.politicaTratamientoDatos.TerminosCondiciones)} />}
                        title={<div dangerouslySetInnerHTML={this.innerHtml(this.state.politicaTratamientoDatos.Title)} />}
                    />
                    : null}

                {this.state.showModalPlanVital == true ?
                    <AlertModal
                        planVital={true}
                        showModal={true}
                        handleHide={() => {
                            this.handleHide.bind(this)
                            this.props.updateState(this.state.form, 3);
                        }}
                        msg={<div dangerouslySetInnerHTML={this.innerHtml(this.state.politicaTratamientoDatosPlanVital.TerminosCondiciones)} />}
                        title={<div dangerouslySetInnerHTML={this.innerHtml(this.state.politicaTratamientoDatosPlanVital.Title)} />}
                    />
                    : null}
                <div className={'cotizar-is-authenticated' + (this.props.isAuthenticated ? ' hidden' : '')}>
                    Si tienes un usuario y contraseña Compensar <a href={loginURL}>Inicia Sesión</a> para una respuesta más detallada y para poder iniciar tu compra.
                </div>
                <div className={'container-fluid cotizar-basic-form' + (this.props.isAuthenticated ? ' border-top' : '')}>
                    <form className="form-horizontal formulario-entrada" data-list-name="sp-forms-form">
                        <div className="col-md-10 col-md-offset-1 col-md-offset-right-1 col-sm-10 col-sm-offset-1 col-sm-offset-right-1 col-xs-12 clearfix">
                            <div className={'form-group margin-sides-30' + (this.state.form.fullName.valid ? '' : ' has-error')}>
                                <label htmlFor="fullName" className="col-md-4 col-sm-4 col-xs-12 control-label">
                                    <span>Nombre: *</span> <br />
                                    <span className="detail-label">Nombre completo con apellidos</span>
                                </label>
                                <div className="col-md-8 col-sm-8 col-xs-12">
                                    <input type="text" id="fullName" name="fullName" className="form-control" tabIndex="0" maxLength="105" value={this.state.form.fullName.value} onChange={this.handleInputChange} onBlur={this.handleBlur} maxLength={50} onPaste={(e) => e.preventDefault()} placeholder="Ingresa tus nombres" autocomplete="off" />
                                    <p className={this.state.form.fullName.valid ? 'hidden' : 'error'}>Nombre completo {this.errorMessages[this.state.form.fullName.error]}</p>
                                </div>
                            </div>
                            <div className='form-group margin-sides-30'>
                                <label htmlFor="identificationNumber" className="col-md-4 col-sm-4 col-xs-12 control-label">
                                    <span>Documento de Identidad*</span> <br />
                                    <span className="detail-label">Ingresa los números sin puntos</span>
                                </label>
                                <div className="col-md-8 col-sm-8 col-xs-12">
                                    <div className="row">
                                        <div className={'col-md-4 col-sm-5 col-xs-6' + (this.state.form.identificationType.value === 'Seleccionar' && !this.state.isSubmitted || this.state.form.identificationType.value !== 'Seleccionar' ? '' : ' has-error')}>
                                            <DropdownButton title={this.state.form.identificationType.value} id="identificationType" className="dropdown-custom" bsStyle="">
                                                {
                                                    this.state.typeDocList.map(item => {
                                                        return (
                                                            <MenuItem
                                                                key={item.CSIdDocumentoText}
                                                                eventKey={item.CSDocumentoIdentidadText}
                                                                className={this.state.form.identificationType.value === item.CSDocumentoIdentidadText ? 'active' : ''}
                                                                onClick={() => this.handleSelect(item)}>
                                                                <span>{item.CSDocumentoIdentidadText}</span>
                                                            </MenuItem>
                                                        )
                                                    })
                                                }
                                            </DropdownButton>
                                            <p className={this.state.form.identificationType.value === 'Seleccionar' && !this.state.isSubmitted || this.state.form.identificationType.value !== 'Seleccionar' ? 'hidden' : 'error'}>Tipo de documento es requerido</p>
                                        </div>
                                        <div className={'col-md-8 col-sm-7 col-xs-6' + (this.state.form.identificationNumber.valid ? '' : ' has-error')}>
                                            <input type="text" id="identificationNumber" name="identificationNumber" className="form-control" tabIndex="1" maxLength={12} value={this.state.form.identificationNumber.value} onChange={this.handleInputChange} onBlur={this.handleBlur} placeholder="Ingresa el número" autocomplete="off" />
                                            <p className={this.state.form.identificationNumber.valid ? 'hidden' : 'error'}>Documento de Identidad {this.errorMessages[this.state.form.identificationNumber.error]}</p>
                                        </div>
                                    </div>
                          
                                </div>
                            </div>
                            <div className={'form-group margin-sides-30' + (this.state.form.phone.valid ? '' : ' has-error')}>
                                <label htmlFor="phone" className="col-md-4 col-sm-4 col-xs-12 control-label">Teléfono Móvil:*</label>
                                <div className="col-md-8 col-sm-8 col-xs-12">
                                    <input type="text" id="phone" name="phone" className="form-control input-med-size" pattern=".{10,10}" tabIndex="3" maxLength={10} minLength={10} value={this.state.form.phone.value} onChange={this.handleInputChange} onBlur={this.handleBlur} placeholder="Ingresa tu teléfono móvil" autocomplete="off" />
                                    <p className={this.state.form.phone.valid ? 'hidden' : 'error'}>Teléfono Móvil {this.errorMessages[this.state.form.phone.error]}</p>
                                </div>
                            </div>
                            <div className={'form-group margin-sides-30' + (this.state.form.email.valid ? '' : ' has-error')}>
                                <label htmlFor="email" className="col-md-4 col-sm-4 col-xs-12 control-label">¿Cúal es tu correo personal?</label>
                                <div className="col-md-8 col-sm-8 col-xs-12">
                                    <input
                                        value={this.state.form.email.value}
                                        onPaste={(e) => e.preventDefault()}
                                        onChange={this.handleInputChange}
                                        onBlur={this.handleBlur}
                                        onFocus={this.handleFocus}
                                        onClick={this.setCursorAtBegin}
                                        type="text"
                                        id="email"
                                        name="email"
                                        className="form-control input-med-size"
                                        tabIndex="4"
                                        maxLength="245"
                                        placeholder="Ingresa tu correo electrónico"
                                        autocomplete="off"
                                    />
                                    {this.state.form.email.valid && this.state.form.email.value !== '' ?
                                        <span className="check-container">
                                            <i className={'fa ' + (this.state.form.email.valid && this.state.form.email.value !== '' ? 'fa-check ' : '')}></i>
                                        </span> :
                                        ''
                                    }
                                    {this.state.form.email.value === '@' ?
                                        <p className={this.state.form.email.valid ? 'hidden' : 'error'}>{this.props.configurations.MensajeCorreoRequerido}</p>
                                        :
                                        <p className={this.state.form.email.valid ? 'hidden' : 'error'}>{this.props.configurations.MensajeCorreoInvalido}</p>
                                    }
                                </div>
                            </div>
                            <div className={'form-group margin-sides-30' + (this.state.form.confirmEmail.valid ? '' : ' has-error')}>
                                <label htmlFor="confirmEmail" className="col-md-4 col-sm-4 col-xs-12 control-label"><span className="highlighted-text-success">Confírmanos tu correo personal</span></label>
                                <div className="col-md-8 col-sm-8 col-xs-12">

                                    <input
                                        value={this.state.form.confirmEmail.value}
                                        onPaste={(e) => e.preventDefault()}
                                        onChange={this.handleInputChange}
                                        onBlur={this.handleBlur}
                                        onFocus={(e) => this.handleFocus(e)}
                                        onClick={this.setCursorAtBegin}
                                        type="text"
                                        id="confirmEmail"
                                        name="confirmEmail"
                                        className="form-control input-med-size"
                                        tabIndex="5"
                                        maxLength="245"
                                        placeholder="Confirma tu correo electrónico"
                                        autocomplete="off"
                                    />
                                    {this.state.form.confirmEmail.valid && this.state.form.confirmEmail.value !== '' && this.state.form.confirmEmail.value !== '@' ?
                                        <span className="check-container">
                                            <i className={'fa ' + (this.state.form.confirmEmail.valid && this.state.form.confirmEmail.value !== '' && this.state.form.confirmEmail.value !== '@' ? 'fa-check ' : '')}></i>
                                        </span> :
                                        ''
                                    }
                                    {this.state.form.confirmEmail.value === '@' ?
                                        <p className={this.state.form.confirmEmail.valid ? 'hidden' : 'error'}>
                                            {this.props.configurations.MensajeCorreoRequerido}
                                        </p>
                                        :
                                        <p className={this.state.form.confirmEmail.valid ? 'hidden' : 'error'}>
                                            {this.state.form.confirmEmail.value !== this.state.form.email.value ?
                                                <span>
                                                    {this.props.configurations.MensajeCorreoConfirmacion}
                                                </span>
                                                :
                                                <span>
                                                    {this.props.configurations.MensajeCorreoInvalido}
                                                </span>
                                            }
                                        </p>
                                    }
                                    {/* {this.state.form.email.value === '@' ?
                                        <p className={this.state.form.email.valid ? 'hidden' : 'error'}>{this.props.configurations.MensajeCorreoRequerido}</p>
                                        :
                                        <p className={this.state.form.email.valid ? 'hidden' : 'error'}>{this.props.configurations.MensajeCorreoInvalido}</p>
                                    } */}
                                </div>
                            </div>

                        </div>
                        <div className="col-md-10 col-md-offset-1 col-md-offset-right-1 col-sm-10 col-sm-offset-2 col-xs-11 col-xs-offset-1">
                            <div className={'form-group margin-sides-30 no-margin-btm ' + (this.state.form.isContacted.value && !this.state.form.confirmPersonalData.value && this.state.isSubmitted ? ' has-error' : '')}>
                                <div className="col-md-9 col-md-offset-2 col-md-offset-right-1 col-sm-12 col-xs-12 margin-btn-10 chk-container">
                                    <input type="checkbox" id="confirmPersonalData" className="chk-style" name="confirmPersonalData" checked={this.state.form.confirmPersonalData.value} onChange={this.handleInputChange} autocomplete="off" />
                                    <label className="control-label chk-label"><span className="detail-label" onClick={() => this.handleHide(true)}><a>Autorización de tratamiento de los datos personales</a></span></label>
                                    <p onClick={() => this.handleHide(true)} className={this.state.form.isContacted.value && !this.state.form.confirmPersonalData.value && this.state.isSubmitted ? 'error' : 'hidden'}>Autorización de tratamiento de los datos personales {this.errorMessages['required']}</p>
                                </div>
                            </div>
                            <div className="form-group margin-sides-30">
                                <div className="col-md-9 col-md-offset-2 col-md-offset-right-1 col-sm-12 col-xs-12 margin-btn-10 chk-container">
                                    <input type="checkbox" id="confirmEmailMessage" className="chk-style" name="confirmEmailMessage" checked={this.state.form.confirmEmailMessage.value} onChange={this.handleInputChange} autocomplete="off" />
                                    <label htmlFor="confirmEmailMessage" className="control-label chk-label"><span className="detail-label">{this.props.configurations.AceptoInformacionCorreo}</span></label>
                                </div>
                                <div className="col-md-9 col-md-offset-2 col-md-offset-right-1 col-sm-12 col-xs-12 margin-btn-10 chk-container">
                                    <input type="checkbox" id="confirmTextMessage" className="chk-style" name="confirmTextMessage" checked={this.state.form.confirmTextMessage.value} onChange={this.handleInputChange} autocomplete="off" />
                                    <label htmlFor="confirmTextMessage" className="control-label chk-label"><span className="detail-label">{this.props.configurations.AceptoMensajesTexto}</span></label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <hr className="hr-line-div-elem" />
                            <div className="form-group">
                                <div className="col-md-12 col-sm-12 col-xs-12 chooseOption">
                                    <button id="submit-form" type="submit" className="btn btn-primary" onClick={this.handleSubmit} disabled={!this.state.formIsValid}>Cotiza Plan Complementario Especial</button>

                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-md-12 col-sm-12 col-xs-12 chooseOption">
                                    <button type="button" className="btn btn-primary-planvital" onClick={() => this.handlePlanVital()} disabled={!this.state.formIsValid}>Cotiza Plan Vital</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="cotizar-important hidden-xs">
                    <strong>IMPORTANTE:</strong> {this.props.configurations['Importante']}
                </div>
            </div>
        );
    }
}
const DropdownButton = ReactBootstrap.DropdownButton;
const MenuItem = ReactBootstrap.MenuItem;